"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOneTrustEnabled = void 0;
/**
 * @param application Name of the application. Example: "destination_guide"
 * @param experimentMetaData Metadata for experiment - privacy_compliance_onetrust. Example: { "destination_guide": 1, "microsites": 0 }
 * @returns boolean - whether oneTrust is enabled on the application
 */
const isOneTrustEnabled = (application, experimentMetaData) => {
    return !!experimentMetaData && experimentMetaData[application] === 1;
};
exports.isOneTrustEnabled = isOneTrustEnabled;
